import Formulaire from './components/Formulaire.vue';

const routes = [
    { path: '/', component: Formulaire, name: 'formulaire' },
];

export default routes;